/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { classNames } from 'primereact/utils';

interface Props {
  text: string;
  copyText?: string;
  className?: string;
  iconClassName?: string;
  textStyle?: React.CSSProperties;
}

export const CopyText: React.FC<Props> = ({ text, copyText, className, iconClassName, textStyle }) => {
  return (
    <div style={textStyle} className={classNames('flex align-items-center cursor-pointer', className)}>
      <i
        onClick={(e) => {
          e.stopPropagation();
          navigator.clipboard.writeText(copyText ?? text).then(() => {
            const target = e.target as HTMLElement;
            target.classList.add('text-green-700', 'pi-check-square');
            setTimeout(() => {
              target.classList.remove('text-green-700', 'pi-check-square');
            }, 1000);
          });
        }}
        className={classNames('pi pi-clipboard mr-1', iconClassName)}
      />
      <div className="white-space-nowrap overflow-hidden text-overflow-ellipsis" style={textStyle}>
        {text}
      </div>
    </div>
  );
};
